import { render, staticRenderFns } from "./ConfirmPurchase.vue?vue&type=template&id=3d2ef274&"
import script from "./ConfirmPurchase.vue?vue&type=script&lang=ts&"
export * from "./ConfirmPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports